import { Record, List } from 'immutable';
import {
  SEARCH_REQUEST,
  SEARCH_SUCCESS,
  SEARCH_FAILURE,
  SEARCH_CLEAR,
  SET_SEARCH_QUERY
} from './actions';

export const SearchResult = new Record({
  id: 0,
  name: '',
  sport: '',
  startTime: '',
  metaTags: new List(),
  participants: new List(),
  devicePlatform: '',
  score: 0,
  type: ''
});

const MetaTag = new Record({
  id: 0,
  name: '',
  type: '',
  urlName: '',
  level: ''
});

const InitialState = new Record({
  results: new List(),
  value: '',
  loading: false
});

export const initialState = new InitialState();

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SEARCH_REQUEST: {
      return state.set('loading', true);
    }
    case SET_SEARCH_QUERY: {
      return state
        .set('value', payload)
        .set('loading', payload.length > 2);
    }
    case SEARCH_SUCCESS: {
      const { results } = payload;

      return state.merge({
        loading: false,
        results: results.map(({
          id,
          name,
          type: itemType,
          sport,
          startTime,
          score,
          metaTags = [],
          devicePlatform,
          participants = [],
        }) => new SearchResult({
          id,
          name,
          type: itemType,
          sport,
          startTime,
          score,
          metaTags: new List(metaTags).map(v => new MetaTag(v)),
          participants: new List(participants),
          devicePlatform,
        }))
      });
    }
    case SEARCH_FAILURE: {
      return state.merge({
        loading: false,
        results: new List()
      });
    }
    case SEARCH_CLEAR: {
      return state.merge({
        loading: false,
        value: '',
        results: new List()
      });
    }
    default: {
      return state;
    }
  }
};
